<template>
  <ChartLayout :title="title" units="years" palette="tints">
    <DataGetter
      :url="apiRoute"
      :params="{
        year: 2022,
        indicator: ['Fundings of start-ups'],
        category: categories,
        techSector: grouping,
        countryISO: selectedCountries.map((country) => country.iso3),
        unit: 'Years',
      }"
      v-slot="{ data }"
    >
      <DataSlicer
        :data="data"
        x-axis-dimension="category"
        y-axis-dimension="countryISO"
        value-dimension="value"
        v-slot="{ slicedData }"
      >
        <Chart
          :options="{
            ...chartOptions,
            series: slicedData.map((series, i) => ({
              ...series,
              name: getNameByISO(series.name),
              colorIndex: series.name === 'WORLD' ? 99 : i % 20,
              data: [...series.data].sort(
                (a, b) => categories.indexOf(a[0]) - categories.indexOf(b[0])
              ),
            })),
          }"
        />
      </DataSlicer>
    </DataGetter>
  </ChartLayout>
</template>

<script>
import { Chart } from "highcharts-vue";
import ChartOptions, {
  ChartLayout,
} from "@international-energy-agency/vue-ui/highcharts";
import { DataGetter, DataSlicer } from "@international-energy-agency/vue-ui";
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    apiRoute: {
      type: String,
      default: "https://api.iea.org",
    },
    selectedCountries: {
      type: Array,
      required: true,
    },
    grouping: {
      type: String,
      required: true,
    },
  },
  components: {
    Chart,
    ChartLayout,
    DataGetter,
    DataSlicer,
  },
  data() {
    const categories = ["Early stage", "Later stage"];
    return {
      categories,
      chartOptions: ChartOptions.buildOptions(
        {
          xAxis: {
            type: "category",
            categories,
            className: "highcharts-show-grid",
          },
          yAxis: {
            max: 14,
            min: 0,
            className: "highcharts-show-grid",
          },
          tooltip: {
            valueSuffix: " years",
          },
          plotOptions: {
            line: {
              marker: {
                enabled: true,
              },
              dataLabels: {
                enabled: true,
                padding: 0,
                x: -8,
                align: "right",
                verticalAlign: "middle",
                formatter: function () {
                  if (this.point.x === 0) return this.series.name;
                },
              },
              showInLegend: true,
            },
          },
        },
        "line"
      ),
    };
  },
  methods: {
    getNameByISO(iso) {
      if (iso === "WORLD") return "World";
      return this.selectedCountries.find((country) => country.iso3 === iso)
        ?.name;
    },
  },
};
</script>
